<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="model.email"></el-input>
            </el-form-item>
            <el-form-item label="车表ID：" prop="car_info_id">
                <el-input v-model="model.car_info_id"></el-input>
            </el-form-item>
            <el-form-item label="车辆ID：" prop="vehicle_id">
                <el-input v-model="model.vehicle_id"></el-input>
            </el-form-item>
            <el-form-item label="VIN：" prop="vin">
                <el-input v-model="model.vin"></el-input>
            </el-form-item>
            <el-form-item label="车型：" prop="car_type">
                <el-input v-model="model.car_type"></el-input>
            </el-form-item>
            <el-form-item label="版本：" prop="version">
                <el-input v-model="model.version"></el-input>
            </el-form-item>
            <el-form-item label="交付日期：" prop="delivered_date">
                <el-input v-model="model.delivered_date"></el-input>
            </el-form-item>
            <el-form-item label="满电续航(km)：" prop="full_endurance">
                <el-input v-model="model.full_endurance"></el-input>
            </el-form-item>
            <el-form-item label="电池容量(度)：" prop="full_battery_capacity">
                <el-input v-model="model.full_battery_capacity"></el-input>
            </el-form-item>
            <el-form-item label="提交时间：" prop="add_time">
                <el-input v-model="model.add_time"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'batteryFeedbackEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                car_info_id: '',
                vehicle_id: '',
                vin: '',
                car_type: '',
                version: '',
                delivered_date: '',
                full_endurance: '',
                full_battery_capacity: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/batteryfeedback/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/batteryfeedback/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>